import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
import { getQueryString } from '@/utils/common'
export const pagingUserTickets = async (params: object) => {
  return await POST({
    url: Api.pagingUserTickets,
    data: params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
